import { render, staticRenderFns } from "./BusinessFrontPageView.vue?vue&type=template&id=ece3ce52&scoped=true&"
import script from "./BusinessFrontPageView.vue?vue&type=script&lang=ts&"
export * from "./BusinessFrontPageView.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessFrontPageView.vue?vue&type=style&index=0&id=ece3ce52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece3ce52",
  null
  
)

export default component.exports